import useUserTokenStore from "@/stores/user-token.store";
import { Permission } from "./Permission.enum";
import { permissionMap } from "./permissionMap";

export function withPermission<P extends object>(
  Wrapped: React.ComponentType<P>,
  opts: { allOf?: Permission[]; oneOf?: Permission[] }
) {
  const WithPermissionWrapper: React.FC<P> = (props) => {
    const { permissions } = useUserTokenStore();

    const hasAll =
      !opts.allOf ||
      opts.allOf.every((p) => permissions.includes(permissionMap[p]));
    const hasOne =
      !opts.oneOf ||
      opts.oneOf.some((p) => permissions.includes(permissionMap[p]));
    const hasPermission = hasAll && hasOne;

    if (!hasPermission) return null;
    return <Wrapped {...props} />;
  };

  WithPermissionWrapper.displayName = `withPermission(${
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (Wrapped as any).displayName || Wrapped.name || "Component"
  })`;

  return WithPermissionWrapper;
}

export function useHasPermission() {
  const { permissions } = useUserTokenStore();

  return (opts: { allOf?: Permission[]; oneOf?: Permission[] }) => {
    const hasAll =
      !opts.allOf ||
      opts.allOf.every((p) => permissions.includes(permissionMap[p]));
    const hasOne =
      !opts.oneOf ||
      opts.oneOf.some((p) => permissions.includes(permissionMap[p]));
    return hasAll && hasOne;
  };
}
